module.exports = __webpack_public_path__ + "static/img/12.56d246f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/zh/12.png
// module id = 1BUp
// module chunks = 0